import dynamic from 'next/dynamic'
import { DemographicsIcon } from 'src/components/insights/icons/demographics'
import { InsightBuilderWidget } from 'src/types/insight-builder'
import preview from 'src/assets/images/widgets-previews/race-ethnicity.png'

const DemographicsRaceEthnicity = dynamic(() => import('src/components/insights/demographics/cards/race-ethnicity'), {
  ssr: false,
})

export const DemographicsRaceEthnicityWidget: InsightBuilderWidget = {
  id: 'race-ethnicity',
  name: 'Race & Ethnicity',
  type: 'Demographics',
  icon: DemographicsIcon,
  component: DemographicsRaceEthnicity,
  supportedResultTypes: ['alphamap-location'],
  preview,
}
